const translations = {
    it: {
      // Step 1
      titleStep1: "Crea il tuo team di crescita",
      subtitleStep1: "Clicca e scegli i tuoi manager di reparto.",
      selectedLabel: "Selezionati",
      avanti: "Avanti",
      indietro: "Indietro",
  
      // Step 2
      titleStep2: "Cos’è importante per te?",
      subtitleStep2: "Vota gli obiettivi di reparto in base alle tue esigenze",
  
      // Step 3
      titleStep3: "Quale modalità di lavoro preferisci?",
      subtitleStep3: "Come vuoi che lavoriamo per te?",
  
      // Step 4
      titleStep4: "La tua Priority Matrix",
      subtitleStep4: "Ecco il risultato delle tue scelte",
      chosenManagers: "I tuoi manager di reparto scelti",
      workModeTitle: "Modalità di lavoro",
      reset: "Reset",
  
      // Step 5-6-7 (user info)
      titleStepUserInfo: "Conosciamoci",
      subtitleStepUserInfo: "Dicci di più su di te e la tua attività",
      namePlaceholder: "Scrivi il tuo nome e cognome",
      emailPlaceholder: "La tua email di riferimento",
      phonePlaceholder: "Il tuo numero di telefono /cellulare",
      companyPlaceholder: "Il nome della tua azienda o attività?",
      websitePlaceholder: "Il tuo sito web",
      nameRequired: "Campo obbligatorio",
      emailRequired: "Campo obbligatorio",
      emailInvalid: "Inserisci un'email valida",
      telRequired: "Campo obbligatorio",
      companyRequired: "Campo obbligatorio",
      siteRequired: "Campo obbligatorio",
  
      // Step 8 (thank you)
      titleStepThanks: "Grazie!",
      subtitleStepThanks: "Abbiamo ricevuto le tue informazioni. Ti contatteremo presto.",
      restart: "Ricomincia",
    },
  
    en: {
      // Step 1
      titleStep1: "Create your growth team",
      subtitleStep1: "Click and choose your department managers.",
      selectedLabel: "Selected",
      avanti: "Next",
      indietro: "Back",
  
      // Step 2
      titleStep2: "What matters most to you?",
      subtitleStep2: "Rate your department goals based on your needs",
  
      // Step 3
      titleStep3: "Which work mode do you prefer?",
      subtitleStep3: "How would you like us to work for you?",
  
      // Step 4
      titleStep4: "Your Priority Matrix",
      subtitleStep4: "Here’s the result of your choices",
      chosenManagers: "Your selected department managers",
      workModeTitle: "Work modes",
      reset: "Reset",
  
      // Step 5-6-7 (user info)
      titleStepUserInfo: "Let’s get to know each other",
      subtitleStepUserInfo: "Tell us more about you and your business",
      namePlaceholder: "Enter your full name",
      emailPlaceholder: "Your reference email",
      phonePlaceholder: "Your phone/mobile number",
      companyPlaceholder: "Your company or business name?",
      websitePlaceholder: "Your website",
      nameRequired: "Required field",
      emailRequired: "Required field",
      emailInvalid: "Please enter a valid email",
      telRequired: "Required field",
      companyRequired: "Required field",
      siteRequired: "Required field",
  
      // Step 8 (thank you)
      titleStepThanks: "Thank you!",
      subtitleStepThanks: "We have received your information. We’ll be in touch soon.",
      restart: "Start Over",
    }
  };
  
  export default translations;
  